import { Link } from 'react-router';
import { AlertCircle, Home } from 'lucide-react';
import PageContainer from '../components/PageContainer';

export default function NotFound() {
  return (
    <PageContainer className="flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card rounded-lg shadow-lg p-8 text-center border border-border">
        <div className="mb-6">
          <AlertCircle className="w-16 h-16 text-destructive mx-auto mb-4" />
          <h1 className="text-4xl mb-2">404</h1>
          <h2 className="text-xl mb-2">Page Not Found</h2>
          <p className="text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <Link
          to="/app"
          className="inline-flex items-center gap-2 px-6 py-3 bg-ring text-white rounded-lg hover:bg-ring/90 transition-colors"
        >
          <Home className="w-5 h-5" />
          Back to Dashboard
        </Link>
      </div>
    </PageContainer>
  );
}
